import type { CanDeactivateFn } from '@angular/router';
import type { LibraryItemDetailPageComponent } from './library-item-detail-page.component';

export const libraryItemPendingChangesGuard: CanDeactivateFn<LibraryItemDetailPageComponent> = (component) => component.canLeave();
